/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { get } from 'lodash';
import { keyColors } from '../../../styles/colors';
import { Container, Column, Row } from '../../../styles/Grid';
import Spacer from '../../ui/Spacer';
import DotComponent from '../../ui/DotComponent';
import ArrowDown from '../../ui/ArrowDown';
import { fieldHasValue, fillEmptyValues } from '../../../utils/sitecore';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import * as styles from './index.styles';

class HeroFull extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const fields = fillEmptyValues(props.fields, {
      DescriptionLeft: '',
      DescriptionRight: '',
      Headline: '',
      Section: '',
      SubSection: '',
    });

    const pageEditing = get(props, 'sitecoreContext.pageEditing', false);
    const sectionField = pageEditing || fieldHasValue(fields.Section);
    const subSectionField = pageEditing || fieldHasValue(fields.Subsection);
    const descriptionRightField =
      pageEditing || fieldHasValue(fields.DescriptionRight);
    const descriptionLeftField =
      pageEditing || fieldHasValue(fields.DescriptionLeft);

    return (
      <Spacer
        backgroundColor={keyColors.brown10}
        paddingCss={styles.containerPadding}
        customCss={styles.containerSizes}
      >
        <Container>
          <Row>
            <Column cols={{ sm: 6, md: 8, lg: 11 }}>
              <h1 css={styles.heading}>
                <Text field={fields.Headline} />
                <DotComponent />
              </h1>
            </Column>
          </Row>
          <Row>
            <Column cols={{ sm: 6, md: 8, lg: 5 }}>
              {sectionField && (
                <p css={styles.section}>
                  <Text field={fields.Section} editable={false} />
                </p>
              )}
              {subSectionField && (
                <p css={styles.subsection}>
                  <Text field={fields.Subsection} editable={false} />
                </p>
              )}
            </Column>
            <Column cols={{ sm: 6, md: 4, lg: 3 }}>
              {descriptionLeftField && (
                <p css={styles.descriptionLeft}>
                  <Text field={fields.DescriptionLeft} />
                </p>
              )}
            </Column>
            <Column cols={{ sm: 6, md: 4, lg: 3 }}>
              {descriptionRightField && (
                <p css={styles.descriptionRight}>
                  <Text field={fields.DescriptionRight} />
                </p>
              )}
            </Column>
          </Row>
          <ArrowDown type="fullHero" />
        </Container>
      </Spacer>
    );
  }
}

const objectValueType = {
  value: PropTypes.string,
};

HeroFull.displayName = 'HeroFull';

HeroFull.propTypes = {
  fields: PropTypes.shape({
    Headline: PropTypes.shape(objectValueType),
    DescriptionRight: PropTypes.shape(objectValueType),
    DescriptionLeft: PropTypes.shape(objectValueType),
    Section: PropTypes.shape(objectValueType),
    Subsection: PropTypes.shape(objectValueType),
    pageTitle: PropTypes.shape(objectValueType),
  }),
};

export default withSitecoreContext()(HeroFull);
